import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
export class User extends HttpForm {
    delete(user) {
        const url = '/api/user/' + user.id;
        return axios.delete(url)
            .then(() => user.deleted_at = new Date())
            .catch(e => this.setError(e));
    }
    restore(user) {
        const url = '/api/user/' + user.id + '/restore';
        return axios.post(url)
            .then(() => user.deleted_at = null)
            .catch(e => this.setError(e));
    }
    resendInvite(user) {
        const url = '/api/user/' + user.id + '/invite';
        return axios.post(url)
            .then(() => this.setSuccessMessage('User Invited.'))
            .catch(e => this.setError(e));
    }
}
